(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--announcement-bar"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-announcement-bar-section')){
  class StackAnnouncementBarSection extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.blocks = null;
      this.autoRotate = false;
      this.displayDuration = 5000;
      this.currentIndex = 0;
      this.rotationInterval = null;
      this.countdownIntervals = [];
    }

    connectedCallback() {
      // Security check with deferred initialization
      if(!window.stack?.isChecked||!window.stack.isChecked()){
        setTimeout(()=>{
          if(!window.stack?.check||window.stack.check()===false){
            this.remove();
          } else {
            this.init();
          }
        },100);
        return;
      }
      if(!window.stack?.check||window.stack.check()===false){
        this.remove();
        return;
      }

      // Initialize immediately if security check passes
      requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized) return;
      
      this.blocks = this.querySelectorAll('.stack--announcement-bar-block');
      if (this.blocks.length <= 1) return;

      this.autoRotate = this.dataset.autoRotate === 'true';
      this.displayDuration = parseInt(this.dataset.displayDuration) || 5000;

      this.initCountdownTimers();
      this.initCopyButtons();
      this.initNavigation();
      this.initHoverControls();
      this.startRotation();

      this.initialized = true;
    }

    showBlock(index) {
      this.blocks.forEach((block, i) => {
        block.classList.toggle('stack--announcement-bar-active', i === index);
      });
      this.currentIndex = index;
    }

    nextBlock() {
      const nextIndex = (this.currentIndex + 1) % this.blocks.length;
      this.showBlock(nextIndex);
    }

    prevBlock() {
      const prevIndex = this.currentIndex === 0 ? this.blocks.length - 1 : this.currentIndex - 1;
      this.showBlock(prevIndex);
    }

    startRotation() {
      this.stopRotation();
      if (this.autoRotate) {
        this.rotationInterval = setInterval(() => {
          this.nextBlock();
        }, this.displayDuration);
      }
    }

    stopRotation() {
      if (this.rotationInterval) {
        clearInterval(this.rotationInterval);
        this.rotationInterval = null;
      }
    }

    initNavigation() {
      const nextBtn = this.querySelector('.stack--announcement-bar-next');
      const prevBtn = this.querySelector('.stack--announcement-bar-prev');

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          this.stopRotation();
          this.nextBlock();
          setTimeout(() => this.startRotation(), 500);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          this.stopRotation();
          this.prevBlock();
          setTimeout(() => this.startRotation(), 500);
        });
      }
    }

    initHoverControls() {
      this.addEventListener('mouseenter', () => this.stopRotation());
      this.addEventListener('mouseleave', () => this.startRotation());
    }

    initCountdownTimers() {
      const countdownElements = this.querySelectorAll('.stack--announcement-bar-time[data-target-date]');

      countdownElements.forEach(element => {
        const targetDate = new Date(element.dataset.targetDate);

        const updateCountdown = () => {
          const now = new Date().getTime();
          const distance = targetDate.getTime() - now;

          if (distance < 0) {
            element.querySelector('.stack--announcement-bar-countdown').innerHTML = '0:00:00';
            return;
          }

          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);

          const daysEl = element.querySelector('.stack--announcement-bar-days');
          const daysSeparatorEl = element.querySelector('.stack--announcement-bar-days-separator');
          const hoursEl = element.querySelector('.stack--announcement-bar-hours');
          const minutesEl = element.querySelector('.stack--announcement-bar-minutes');
          const secondsEl = element.querySelector('.stack--announcement-bar-seconds');

          // Show/hide days based on whether there are any
          if (daysEl && daysSeparatorEl) {
            if (days > 0) {
              daysEl.style.display = 'inline';
              daysSeparatorEl.style.display = 'inline';
              daysEl.textContent = days;
            } else {
              daysEl.style.display = 'none';
              daysSeparatorEl.style.display = 'none';
            }
          }

          if (hoursEl) hoursEl.textContent = hours.toString().padStart(2, '0');
          if (minutesEl) minutesEl.textContent = minutes.toString().padStart(2, '0');
          if (secondsEl) secondsEl.textContent = seconds.toString().padStart(2, '0');
        };

        updateCountdown();
        const intervalId = setInterval(updateCountdown, 1000);
        this.countdownIntervals.push(intervalId);
      });
    }

    initCopyButtons() {
      const discountWrappers = this.querySelectorAll('.stack--announcement-bar-discount-wrapper');

      discountWrappers.forEach(wrapper => {
        const copyButton = wrapper.querySelector('.stack--announcement-bar-copy-btn');

        if (copyButton) {
          const code = copyButton.dataset.code;
          wrapper.style.cursor = 'pointer';

          const copyToClipboard = () => {
            if (navigator.clipboard) {
              navigator.clipboard.writeText(code).then(() => {
                this.showCopyFeedback(copyButton);
              }).catch(() => {
                this.fallbackCopy(code, copyButton);
              });
            } else {
              this.fallbackCopy(code, copyButton);
            }
          };

          copyButton.addEventListener('click', (e) => {
            e.stopPropagation();
            copyToClipboard();
          });

          wrapper.addEventListener('click', (e) => {
            if (e.target !== copyButton) {
              copyToClipboard();
            }
          });
        }
      });
    }

    fallbackCopy(code, button) {
      const textArea = document.createElement('textarea');
      textArea.value = code;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
        this.showCopyFeedback(button);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }

      document.body.removeChild(textArea);
    }

    showCopyFeedback(button) {
      const originalHTML = button.innerHTML;

      button.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      button.classList.add('copied');

      setTimeout(() => {
        button.innerHTML = originalHTML;
        button.classList.remove('copied');
      }, 2000);
    }

    disconnectedCallback() {
      this.stopRotation();
      this.countdownIntervals.forEach(intervalId => clearInterval(intervalId));
      this.countdownIntervals = [];
      this.initialized = false;
    }
  }

  customElements.define('stack-announcement-bar-section', StackAnnouncementBarSection);
}

// Handle Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId.includes('stack--announcement-bar')) {
    const section = document.querySelector('.stack--announcement-bar');
    if (section && section.tagName.toLowerCase() === 'stack-announcement-bar-section') {
      setTimeout(() => section.init(), 100);
    }
  }
});

document.addEventListener('shopify:section:select', function(event) {
  if (event.detail.sectionId.includes('stack--announcement-bar')) {
    const section = document.querySelector('.stack--announcement-bar');
    if (section && section.tagName.toLowerCase() === 'stack-announcement-bar-section') {
      section.init();
    }
  }
});

document.addEventListener('shopify:section:deselect', function(event) {
  if (event.detail.sectionId.includes('stack--announcement-bar')) {
    const section = document.querySelector('.stack--announcement-bar');
    if (section && section.tagName.toLowerCase() === 'stack-announcement-bar-section') {
      const blocks = section.querySelectorAll('.stack--announcement-bar-block');
      blocks.forEach(block => {
        block.style.animation = 'none';
      });
    }
  }
});

document.addEventListener('shopify:theme:section:reorder', function(event) {
  if (event.detail.sectionId.includes('stack--announcement-bar')) {
    const section = document.querySelector('.stack--announcement-bar');
    if (section && section.tagName.toLowerCase() === 'stack-announcement-bar-section') {
      setTimeout(() => section.init(), 100);
    }
  }
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--story-menu"] && !Shopify.designMode) return;
  try {
    
(async()=>{
const el=document.querySelector('.stack--stories');
if(!el)return;
if(!window.stack?.isChecked||!window.stack.isChecked()){setTimeout(()=>{if(!window.stack?.check||window.stack.check()===false){el.remove()}},100);return;}
if(!window.stack?.check||window.stack.check()===false){el.remove();return;}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--testimonials"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-testimonials-section')){
  class StackTestimonialsSection extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.swiper = null;
    }

    connectedCallback() {
      // Security check with deferred initialization
      if(!window.stack?.isChecked||!window.stack.isChecked()){
        setTimeout(()=>{
          if(!window.stack?.check||window.stack.check()===false){
            this.remove();
          } else {
            this.init();
          }
        },100);
        return;
      }
      if(!window.stack?.check||window.stack.check()===false){
        this.remove();
        return;
      }

      // Initialize immediately if security check passes
      requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized) return;
      
      const layout = this.dataset.layout;
      
      if (layout === 'stack') {
        this.initStackViewMore();
      } else if (layout === 'slider') {
        this.initSwiperSlider();
      }

      this.initialized = true;
    }

    initStackViewMore() {
      const viewMoreBtn = this.querySelector('.stack--testimonials-view-more-btn');
      if (!viewMoreBtn) return;
      
      viewMoreBtn.addEventListener('click', () => {
        const hiddenCards = this.querySelectorAll('.stack--testimonials-card-hidden');
        hiddenCards.forEach(card => {
          card.classList.remove('stack--testimonials-card-hidden');
        });
        viewMoreBtn.parentElement.style.display = 'none';
      });
    }

    initSwiperSlider() {
      const swiperContainer = this.querySelector('.stack--testimonials-swiper');
      if (!swiperContainer) return;
      
      // Wait for Swiper library to load
      if (typeof Swiper === 'undefined') {
        setTimeout(() => this.initSwiperSlider(), 100);
        return;
      }
      
      // Initialize Swiper with configuration
      this.swiper = new Swiper('.stack--testimonials-swiper', {
        // Basic settings
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        speed: 600,
        // Navigation
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        centeredSlides: false,
        slidesPerView: 'auto',
        
        // Accessibility
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous testimonial',
          nextSlideMessage: 'Next testimonial',
          firstSlideMessage: 'This is the first testimonial',
          lastSlideMessage: 'This is the last testimonial',
        },
        
        // Keyboard control
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        
        // Touch/Swipe
        touchRatio: 1,
        touchAngle: 45,
        grabCursor: true,
        touchStartPreventDefault: false,
        
        // Effects
        effect: 'slide',
        fadeEffect: {
          crossFade: true,
        },
      });
    }

    disconnectedCallback() {
      // Cleanup Swiper instance
      if (this.swiper && this.swiper.destroy) {
        this.swiper.destroy(true, true);
      }
      this.initialized = false;
    }
  }

  customElements.define('stack-testimonials-section', StackTestimonialsSection);
}

// Handle Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId.includes('stack--testimonials')) {
    const section = document.querySelector('.stack--testimonials');
    if (section && section.tagName.toLowerCase() === 'stack-testimonials-section') {
      setTimeout(() => section.init(), 100);
    }
  }
});

document.addEventListener('shopify:section:select', function(event) {
  if (event.detail.sectionId.includes('stack--testimonials')) {
    const section = document.querySelector('.stack--testimonials');
    if (section && section.tagName.toLowerCase() === 'stack-testimonials-section') {
      section.init();
    }
  }
});
})();

  } catch(e) { console.error(e); }
})();
})();
